import * as Sentry from '@sentry/browser';

export const init = (dsn, release) => {
  if (dsn) {
    Sentry.init({
      dsn,
      release,
    });
  }
};

export const setUserInfo = (userInfo) => {
  Sentry.configureScope((scope) => {
    scope.setUser(userInfo);
  });
};

// Documentation : https://docs.sentry.io/platforms/javascript/usage/#capturing-errors
// possibe values for level : "fatal", "critical", "error", "warning", "log", "info", and "debug".
// tags : map object consisting string as key value pair
// errors : actual error object
export const captureException = (
  errors,
  level = Sentry.Severity.Warning,
  tags,
) => {
  Sentry.withScope(scope => {
    scope.setLevel(Sentry.Severity.fromString(level));
    Object.entries(tags).forEach(([key, value]) => {
      scope.setTag(key, value);
    });
    Sentry.captureException(errors);
  });
};

// Documentation : https://docs.sentry.io/platforms/javascript/usage/#capturing-messages
export const captureMessage = message => {
  Sentry.captureMessage(message);
};
